/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InitialRequestService {
    /**
     * Initial request to gather version and OS information
     * @returns void
     * @throws ApiError
     */
    public static init({
        version,
        appType,
        os,
    }: {
        version: string,
        appType: string,
        os?: string,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/init',
            query: {
                'version': version,
                'appType': appType,
                'os': os,
            },
            errors: {
                403: `Not authorized (missing API token)`,
            },
        });
    }
}
